module.exports = __webpack_public_path__ + "assets/img/activity-head-back.bbd9de69.png";